// test1192
(1192 && 0);
